(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var card = document.getElementById('cb-card');
    var toggle = document.getElementById('cb-toggle');
    if (!card || !toggle) return;

    toggle.addEventListener('click', function () {
      if (window.innerWidth >= 768) return;
      var open = card.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["euro-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var form      = document.getElementById('et-filter-form');
  var loadingEl = document.getElementById('et-loading');
  var results   = document.getElementById('et-results');

  if (!form) return;

  // Active class on select change
  form.querySelectorAll('[data-et-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var wrapper = this.closest('.et-select-wrapper');
      if (wrapper) wrapper.classList.toggle('et-select-wrapper--active', this.value !== '');
    });
  });

  // Dual range slider
  var rangeMin = document.getElementById('et-range-min');
  var rangeMax = document.getElementById('et-range-max');
  var fill     = document.getElementById('et-range-fill');
  var labelMin = document.getElementById('et-label-min');
  var labelMax = document.getElementById('et-label-max');
  var inputGte = document.getElementById('et-price-gte');
  var inputLte = document.getElementById('et-price-lte');

  function updateSlider() {
    if (!rangeMin || !rangeMax) return;
    var min    = parseFloat(rangeMin.value);
    var max    = parseFloat(rangeMax.value);
    var absMin = parseFloat(rangeMin.min);
    var absMax = parseFloat(rangeMin.max);

    if (min > max) {
      if (this === rangeMin) { rangeMin.value = max; min = max; }
      else                   { rangeMax.value = min; max = min; }
    }

    var leftPct  = ((min - absMin) / (absMax - absMin)) * 100;
    var rightPct = ((max - absMin) / (absMax - absMin)) * 100;

    if (fill)     { fill.style.left = leftPct + '%'; fill.style.width = (rightPct - leftPct) + '%'; }
    if (labelMin) labelMin.textContent = Math.round(min).toLocaleString('es-MX');
    if (labelMax) labelMax.textContent = Math.round(max).toLocaleString('es-MX');
    if (inputGte) inputGte.value = min;
    if (inputLte) inputLte.value = max;
  }

  if (rangeMin) rangeMin.addEventListener('input', updateSlider);
  if (rangeMax) rangeMax.addEventListener('input', updateSlider);
  if (rangeMin && rangeMax) updateSlider.call(null);

  // Show loading overlay on submit
  form.addEventListener('submit', function () {
    if (loadingEl) loadingEl.classList.add('et-loading--visible');
    if (results)   results.classList.add('et-results--loading');
  });

  // Sort grid by inventory (highest first)
  var grid = document.querySelector('.et-grid');
  if (grid) {
    var items = Array.from(grid.children);
    items.sort(function (a, b) {
      return parseInt(b.dataset.inventory || 0, 10) - parseInt(a.dataset.inventory || 0, 10);
    });
    items.forEach(function (item) { grid.appendChild(item); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
